/**
 * Drivers
 */

// React
import React, {FunctionComponent, useContext, useEffect, useState} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  updateDriverActions,
  getVehiclePreferredSourcesAction,
  updateVehiclePreferredSourcesAction,
  getDriverShiftsAction,
  updateDriverShiftsAction,
  updateDriverStatusActions,
  getDriversWalletAction, addWalletDriversTransactionAction,
  //updateDriverStatusActions,
} from '../drivers/actions';
import {Store} from '../../redux/reducers';

// Selector

import {createStructuredSelector} from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectCentersList,
  makeSelectPreferredSources,
  makeSelectPreferredSourcesLoading,
  makeSelectDriverShifts,
  makeSelectDriverShiftsLoading,
  makeSelectActiveCountList,
  makeSelectDeactiveCountList,
  makeSelectDriversWalletList, makeSelectSumWallet,
} from '../drivers/selectors';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  Paper,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  InputBase,
  ClickAwayListener,
} from '@material-ui/core';

// Components
import List from './list';
import Pagination from '@material-ui/lab/Pagination';

// Type
import {
  WalletProps as Props,
  WalletsSelectorProps as SelectorProps,
  Payload,
  Driver,
  DriverShift, DriverWallet,
} from '../drivers/interfaces';
import Icon from '@mdi/react';
import {
  mdiCarInfo,
  mdiCarKey,
  mdiClose,
  mdiMagnify,
  mdiPlus,
  mdiStateMachine,
  mdiTextBoxMultipleOutline,
  mdiCheck,
  mdiCar,
  mdiAccountOutline,
  mdiPhone,
  mdiAccountKey, mdiCreditCard, mdiCreditCardCheckOutline,
} from '@mdi/js';
import clsx from 'clsx';
import RenderFilter, {Filter} from '../../utils/listDaynamicFilter';
import {
  removeEmptyValueObject,
  translateDriversEmploymentStatus,
  translateFleetStatus,
} from '../../utils/helpers';
import Can from '../../components/Can';
import AuthContext from '../../authContext';
import {useForm} from 'react-hook-form';
import theme from '../../theme';
import Modal from '../../components/Modal';
import Detail from '../drivers/detail';
import Add from '../drivers/add';
import {Link} from 'react-router-dom';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    diactiveCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#e5a4a4',
      },
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(2, 3),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: '#f30000',
      },
    },
    link: {
      textDecoration: 'none',
    },
    checkIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: '#039590',
      },
    },
  })
);

const Drivers: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const {register, handleSubmit, reset} = useForm<Inputs>();
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [filters, setFilters] = useState([] as Filter[]);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openDetailPage, setOpenDetailPage] = React.useState(false as boolean);
  const [openCreatePage, setOpenCreatePage] = React.useState(false as boolean);
  const [openShiftDialog, setOpenShiftDialog] = useState(false as boolean);
  const [openSettleDialog, setOpenSettleDialog] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [detailPageId, setDetailPageId] = useState(-1 as number);
  const [previewDriver, setPreviewDriver] = useState({} as Driver);
  const [previewDriverWallet, setPreviewDriverWallet] = useState({} as DriverWallet);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);

  const findDriver = (id: number) => {
    const status = props.driversWalletList.find(driver => driver.id === id)?.status;
    return status && translateFleetStatus(status);
  };

  useEffect(() => {
    getDrivers();
    setupFilters();
  }, [filtersValues]);
  // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const handleDetailPage = (id: number) => {
    setDetailPageId(id);
    setOpenDetailPage(true);
  };
  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const getDrivers = () => {
    const id = props?.match?.params?.id;
    let fleetId = {};
    if (id) {
      fleetId = {fleetId: {equals: id}};
    }
    const {page, size} = filtersValues;
    props.driversDispatch({
      ...filtersValues,
      ...removeEmptyValueObject(fleetId),
      page,
      size,
    });
  };

  const updateDriver = () => {
    props.updateDriverDispatch({body: previewDriver});
    setOpenConfirmUpdateState(false);
  };

  const updateDriverStatus = () => {
    props.updateDriverStatusDispatch({
      body: `"${previewDriver.status}"`,
      id,
    });
    setOpenConfirmUpdateState(false);
  };

  const settleDriverWallet = () => {
    props.walletTransactionDispatch({
      body: {
        reason: 'settle',
        type: 'SETTLE',
        description: '',
        amount: ''
      },
      id: previewDriverWallet.driverId,
    });
    setOpenSettleDialog(false);
  };

  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'drivers:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'input',
            id: 'name.contains',
            label: 'نام راننده',
            icon: mdiAccountOutline,
          },
          {
            type: 'input',
            id: 'phoneNumber.contains',
            label: 'شماره تماس راننده',
            icon: mdiPhone,
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه راننده',
            icon: mdiCarKey,
          },
          {
            type: 'select',
            id: 'vehicleClass.equals',
            label: 'نوع خودرو',
            data: [
              'CAR',
              'MOTORCYCLE',
              'PICKUPS',
              'TRUCK',
              'HEAVY_TRUCK',
              'AIRPLANE',
            ],
            translateType: 'common',
            icon: mdiCarInfo,
          },
          {
            type: 'select',
            id: 'employmentStatus.equals',
            label: 'وضعیت راننده',
            data: ['SUSPENDED', 'ACTIVE', 'OFF', 'REGISTERED'],
            translateType: 'driver',
            icon: mdiStateMachine,
          },
        ]);
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'name.contains',
            label: 'نام راننده',
            icon: mdiAccountOutline,
          },
          {
            type: 'input',
            id: 'phoneNumber.contains',
            label: 'شماره تماس راننده',
            icon: mdiPhone,
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه راننده',
            icon: mdiAccountKey,
          },
          {
            type: 'select',
            id: 'vehicleClass.equals',
            label: 'نوع خودرو',
            data: [
              'CAR',
              'MOTORCYCLE',
              'PICKUPS',
              'TRUCK',
              'HEAVY_TRUCK',
              'AIRPLANE',
            ],
            translateType: 'common',
            icon: mdiCarInfo,
          },
          {
            type: 'select',
            id: 'employmentStatus.equals',
            label: 'وضعیت راننده',
            data: ['SUSPENDED', 'ACTIVE', 'OFF', 'REGISTERED'],
            translateType: 'driver',
            icon: mdiStateMachine,
          },
        ]);
      },
    });
  };

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    reset({});
    setOpenFilterBox(false);
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
        'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleOpenConfirmUpdate = (body: Driver) => {
    const {id} = body;
    setOpenConfirmUpdateState(true);
    id && setId(id);
    setPreviewDriver(body);
  };

  const handleOpenShiftDialog = (body: Driver) => {
    const {id, shiftId} = body;
    setOpenShiftDialog(true);
    setId(id);
    setPreviewDriver(body);
    props.getDriverShiftsDispatch(shiftId);
  };

  const handleOpenSettleDialog = (body: DriverWallet) => {
    setOpenSettleDialog(true);
    setPreviewDriverWallet(body);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" component="h2">
            {`کیف پول رانندگان
              ${
                props?.match?.params?.id
                  ? 'ناوگان - ' + String(props?.match?.params?.id)
                  : ''
              }
            `}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.searchBox}>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.input}>
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
              >
                <Icon
                  path={mdiMagnify}
                  size={1}
                  className={classes.magnifyIcon}
                />
              </IconButton>
              <InputBase
                className={classes.input}
                name="productName.contains"
                placeholder="نام راننده"
                inputRef={register({required: true})}
              />
            </form>

            <ClickAwayListener onClickAway={handleClickAway}>
              <div>
                <Button
                  type="button"
                  onClick={handleClick}
                  className={classes.iconButton}
                  aria-label="search"
                >
                  {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
                </Button>
                {openFilterBox ? (
                  <div
                    className={clsx(classes.filterBox, {
                      [classes.filterOpen]: openFilterBox,
                    })}
                  >
                    <RenderFilter
                      filters={filters}
                      onFilter={(filtersValues: any) => {
                        setFiltersValues({
                          ...removeEmptyValueObject(filtersValues),
                          page: 0,
                          size: 10,
                        });
                        setOpenFilterBox(false);
                      }}
                      setOpenFilterBox={setOpenFilterBox}
                    />
                  </div>
                ) : null}
              </div>
            </ClickAwayListener>
          </div>
          {/* <Divider /> */}
        </Grid>
        <Grid
          style={{margin: 0}}
          container
          spacing={5}
          alignItems="center"
          justify="space-between"
        >
          <Grid item>
            <div>
              <span style={{color: '#8a8a8a'}}>{'مجموع موجودی رانندگان (ریال):'}</span>
              <span style={{paddingRight: '10px'}}>{new Intl.NumberFormat('fa-IR').format(props.sumWallet)}</span>
            </div>
          </Grid>
          <Grid item>
            <Link className={classes.link} to={`/drivers-wallet/bulk-charge`}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiCreditCard} size={1} />}
              >
                {'شارژ دسته جمعی رانندگان'}
              </Button>
            </Link>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            {props.loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              <>
                <List
                  data={props.driversWalletList}
                  fleetId={props.match.params.id}
                  sourcesList={props.centersList}
                  preferredSourcesLoading={props.preferredSourcesLoading}
                  preferredSources={props.preferredSources}
                  handleConfirmUpdate={handleOpenConfirmUpdate}
                  handleOpenShiftDialog={handleOpenShiftDialog}
                  handleOpenSettleDialog={handleOpenSettleDialog}
                  handleOpenDetailPage={id => handleDetailPage(id)}
                  updateVehicleSource={
                    props.updateVehiclePreferredSourcesDispatch
                  }
                />
              </>
            )}
          </Paper>
        </Grid>
        <Grid container spacing={5} style={{margin: 0}}>
          <Grid id="showFilter" item xs={12} sm={6}>
            {props.driversWalletList && (
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleCloseSelect}
                  className={classes.showCount}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid xs={12} sm={6} container item direction="row-reverse">
            {props.driversWalletList && (
              <Pagination
                count={Math.ceil(props.count / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Modal
        maxWidth="lg"
        onClose={() => setOpenDetailPage(false)}
        open={openDetailPage}
        title={
          <div style={{textAlign: 'center'}}>
            <Icon
              path={mdiTextBoxMultipleOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<Detail id={detailPageId} />}
      />
      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={() => setOpenConfirmUpdateState(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              // className={classes.closeButton}
              onClick={() => setOpenConfirmUpdateState(false)}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div
            className={
              previewDriver.status === 'ACTIVE'
                ? classes.checkIcon
                : classes.editIcon
            }
          >
            <Icon
              path={previewDriver.status === 'ACTIVE' ? mdiCheck : mdiClose}
              size={4}
              color={
                previewDriver.status === 'ACTIVE'
                  ? theme.palette.green.main
                  : '#f30000'
              }
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از 
            "${translateDriversEmploymentStatus(previewDriver.status)}"
            کردن راننده با شناسه 
            "${previewDriver.id}"
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={() => setOpenConfirmUpdateState(false)}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={updateDriverStatus}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openSettleDialog}
        onClose={() => setOpenSettleDialog(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              // className={classes.closeButton}
              onClick={() => setOpenSettleDialog(false)}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div
            className={classes.checkIcon}
          >
            <Icon
              path={ mdiCreditCardCheckOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`آیا از 
            تسویه حساب مبلغ 
            "${previewDriverWallet.amount}"
            ریال کیف پول راننده 
             "${previewDriverWallet.driverName}"
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={() => setOpenSettleDialog(false)}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={settleDriverWallet}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  driversWalletList: makeSelectDriversWalletList(),
  centersList: makeSelectCentersList(),
  preferredSources: makeSelectPreferredSources(),
  count: makeSelectCountList(),
  sumWallet: makeSelectSumWallet(),
  countActive: makeSelectActiveCountList(),
  countDeactive: makeSelectDeactiveCountList(),
  preferredSourcesLoading: makeSelectPreferredSourcesLoading(),
  loading: makeSelectLoading(),
  driverShifts: makeSelectDriverShifts(),
  driverShiftsLoading: makeSelectDriverShiftsLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    driversDispatch: (payload: Payload) => dispatch(getDriversWalletAction(payload)),
    walletTransactionDispatch: (payload: Payload) =>
      dispatch(addWalletDriversTransactionAction(payload)),
    getVehiclePreferredSourcesDispatch: (id: number) =>
      dispatch(getVehiclePreferredSourcesAction(id)),
    getDriverShiftsDispatch: (id: number) =>
      dispatch(getDriverShiftsAction({id})),
    updateVehiclePreferredSourcesDispatch: (payload: {
      id: number;
      body: number[];
    }) => dispatch(updateVehiclePreferredSourcesAction(payload)),
    updateDriverShiftsDispatch: (payload: {body: DriverShift}) =>
      dispatch(updateDriverShiftsAction(payload)),
    updateDriverDispatch: (payload: {body: Driver}) =>
      dispatch(updateDriverActions(payload)),
    updateDriverStatusDispatch: (payload: Payload) =>
      dispatch(updateDriverStatusActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Drivers);
